<template>

  <span>
    <!-- User with avatar -->
    <span class="rounded-circle user-avatar"
          style="position:relative"
          v-bind:style="{ 'background-image': 'url(' + user.avatar + ')' }"
          :class="size ? size : 'xs'"
          v-b-tooltip.hover
          :title="user.name"
          v-if="user && user.avatar"
    >
      <span v-if="object.owner && !noOwner">
        <font-awesome-icon
            icon="star"
            class="star"
        />
      </span>
    </span>

    <!-- User with logo -->
    <span class="rounded-circle user-avatar"
          style="position:relative"
          v-bind:style="{ 'background-image': 'url(' + user.logo + ')' }"
          :class="size ? size : 'xs'"
          v-b-tooltip.hover
          :title="user.name"
          v-if="user && user.logo"
    >
      <span v-if="object.owner && !noOwner">
        <font-awesome-icon
            icon="star"
            class="star"
        />
      </span>
    </span>


    <!-- No user avatar-->
    <span class="rounded-circle user-avatar"
          style="position:relative"
          v-bind:style="{ 'background-image': 'url(' + defaultLink + ')' }"
          :class="size ? size : 'xs'"
          v-b-tooltip.hover
          :title="user.name"
          v-if="!user.logo && !user.avatar && object.who_am_i != 'App\\Maintenance\\ThirdParty\\Models\\Vendor' && user.who_am_i != 'App\\Client\\Models\\Client'"
    >
      <span v-if="object.owner && !noOwner">
        <font-awesome-icon
            icon="star"
            class="star"
        />
      </span>
    </span>

    <!-- No vendor avatar -->
    <span class="rounded-circle user-avatar"
          style="position:relative"
          v-bind:style="{ 'background-image': 'url(' + defaultVendorLink + ')' }"
          :class="size ? size : 'xs'"
          v-b-tooltip.hover
          :title="user.name"
          v-if="!user.logo && !user.avatar && (user.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\Vendor' || user.who_am_i == 'App\\Client\\Models\\Client')"
    >
      <span v-if="object.owner && !noOwner">
        <font-awesome-icon
            icon="star"
            class="star"
        />
      </span>
    </span>
  </span>





</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import {config} from '@/config.js'

  export default {
    name: 'Avatar',
    props: {
      object: {
        required: true
      },
      size: {
        type: String
      },
      noOwner: {
        type: Boolean
      }
    },
    data: function() {
      return {
        user: {},
        defaultLink: require('@/assets/avatar.png'),
        defaultVendorLink: require('@/assets/tp-logo.png'),
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      object: function (value) {
        if (value && value.id) {
          this.user = value
        } else {
          let self = this;
          // Check if property is number (ID of the user) before calling API
          if (typeof value == "number") {
            piincHttp.get('users/id/' + value, { params:
              {
                client: this.getClient.slug
              }
            }).then(function(response) {
              self.user = response.data;
            }, function() {});
          }
        }
      }
    },
    methods: {

    },
    created () {
      if (this.object && this.object.id) {
        this.user = this.object
      } else {
        let self = this;
        // Check if property is number (ID of the user) before calling API
        if (typeof this.object == "number") {
          piincHttp.get('users/id/' + this.object, { params:
            {
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.user = response.data;
          }, function() {});
        }
      }
    }
  }
</script>
